import React from 'react'
import { Box } from '@mui/material'

import moment from 'moment'
import { useSelector } from 'react-redux'

import { getDynamicLightingThresholdLabel } from '../../../../helpers/dynamicLightingThresholds'
import { DetailRow } from './DetailRow/DetailRow'

export const DynamicProfileDetails = ({ profile, dense = false }) => {

  const cmAdaptativeThresholdsSunrise = useSelector(state => state.contracts.cmAdaptativeThresholdsSunrise)
  const cmAdaptativeThresholdsSunset = useSelector(state => state.contracts.cmAdaptativeThresholdsSunset)

  if (!profile) {
    return null
  }

  const getThresholdText = (value, thresholdOptions) => {
    const label = getDynamicLightingThresholdLabel(value, thresholdOptions)

    return label ? label : '-'
  }

  return (
    <Box
      sx={{
        px: dense ? 1.5 : 3,
        py: dense ? 1 : 2
      }}
      className='animate__animated animate__fadeIn'
    >
      <DetailRow
        label={'Nombre'}
        value={profile.name}
        dense={dense}
      />

      <DetailRow
        label={'Fecha de creación'}
        value={
          profile.date
            ? moment(profile.date).format('DD MMM yyyy HH:mm')
            : '-'
        }
        dense={dense}
      />

      <DetailRow
        label={'Umbral encendido ocaso'}
        value={getThresholdText(profile.sunset_switch_on_threshold, cmAdaptativeThresholdsSunset)}
        dense={dense}
      />

      <DetailRow
        label={'Umbral encendido orto'}
        value={getThresholdText(profile.sunrise_switch_on_threshold, cmAdaptativeThresholdsSunrise)}
        dense={dense}
      />

      <DetailRow
        label={'Descripción'}
        value={profile.description ? profile.description : 'Sin descripción'}
        multiline
        dense={dense}
      />
    </Box>
  )
}